import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Form, Schema } from 'rsuite';
import Swal from 'sweetalert2';
import reinstatementService from '../../../../../services/Internal/Reinstatement/PE/peReinstatement.service';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import Information from '../../../../Shared/Card/Information';
import Issues from '../../../../Shared/Card/Issues';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons'
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import { GetReinstatementInformationContent } from '../../../../Shared/InformationContent/PeInformation';
import Courses from './Courses'
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function CpdRequirementsPage() {
    const push = useNavigate();
    const [formModel, setFormModel] = useState({
        electronicSignature: "",
    });
    const reinstatementId = useSelector(x => x.currentApplicationId);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [hasFiles, setHasFiles] = useState(false);
    const sectionId = 5;
    const routes = useSelector(x => x.currentRoutes);
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const { StringType } = Schema.Types;
    const model = Schema.Model({
        electronicSignature: StringType().isRequired('This field is required.'),
    });
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Professional Engineer Reinstatement",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "CPD Requirements"
        }
    );
    useEffect(() => {
        reinstatementService.peGetSection(reinstatementId, sectionId).then((response) => {
            setIsComplete(response.data.staffReviewComplete)
            reinstatementService.getIndividualReinstatement(reinstatementId).then((data) => {
                setIsUserEditable(data.data.status.id == 2)
                entityService.getEntity(response.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: data.data?.credential?.formattedLicenseNumber,
                            applicationDate: data.data?.dateSubmitted,
                            formType: data.data?.isOverFiveYears ? "Professional Engineer Reinstatement (5 plus years)" : entityInfo.formType
                        })
                });
                setFormModel(response.data);
                setHasLoaded(true);
            });
        })
    }, [])
    const formSubmit = (validation, event) => {
        if (validation) {
            submitData(true);
        }
    }
    const formSave = (event) => {
        submitData();
    }
    const submitData = (isForSubmit) => {
        if (!isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else {
            reinstatementService.pePostCpdComment(reinstatementId, sectionId, formModel.cpdComment).then((result) => {
                reinstatementService.pePostSection(reinstatementId, sectionId, formModel.electronicSignature).then((response) => {
                    reinstatementService.peMarkSectionComplete(reinstatementId, sectionId, isComplete).then((data) => {
                        if (isForSubmit && response.data.id) {
                            push(routes[routes.map(function (x) { return x.sectionId }).indexOf(sectionId) + 1].route)
                        }
                        else if (response.data.id) {
                            Swal.fire("Saved!");
                        }
                        else {
                            Swal.fire("Error saving cpd")
                        }
                    })
                })
            })
        }
    }

    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Information content={GetReinstatementInformationContent("cpdRequirements")} />
                <br />
                {hasLoaded ?
                    <Form model={model} formValue={formModel} onChange={formModel => setFormModel(formModel)} onSubmit={formSubmit} fluid>
                        <Courses
                            isUserEditable={isUserEditable}
                            formModel={formModel}
                            setHasFiles={setHasFiles}
                            hasFiles={hasFiles} />
                        <br />
                        <Issues isUserEditable={isUserEditable} isInternal={true} type={2} sectionId={formModel.id} setIsComplete={setIsComplete} />
                        <FormActionButtons
                            isUserEditable={isUserEditable}
                            backToSectionLink="/internal/pereinstatement/sections"
                            handleSave={formSave}
                            showSectionComplete={true}
                            isComplete={isComplete}
                            isCompleteCallback={setIsComplete} />
                    </Form> : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}

export default CpdRequirementsPage